/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit File/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import CameraOnIcon from 'DesignSystem/Svgs/CameraOnIcon/index'
import DeleteAction from './DeleteAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function File({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Videos/VideosTree/Content/Files/File",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let videoItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'video_item',
path: 'isFirst',
})
let videoIdValueData = fromData.useDataValue({ viewPath,
context: 'video',
path: 'id',
})
let selectedIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'id',
})
let aggregateData = fromAggregate.equals(videoIdValueData, selectedIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  isHoveredManual
  
})
let videoFileNameValueData = fromData.useDataValue({ viewPath,
context: 'video',
path: 'file_name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let videoCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'video',
path: 'created_at',
format: fromFormat.dateISOToDateAndTime,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="File.Horizontal"
  data-view-path={viewPath}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--pt-1-9Dt7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-9Dt7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-9Dt7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-9Dt7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-6-9Dt7': isSelectedHovered ? dtColorsNeutral200 : isHoveredManual ? dtColorsNeutral200 : aggregateData ? dtColorsNeutral200 : dtColorsWhite,'--mt-5-9Dt7': videoItemIsFirstValueData ? "0px" : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="File.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal1}`}
>
<CameraOnIcon
  viewPath={`${viewPath}/CameraOnIcon`}
 width={20}
 height={20}
 marginRight={dtSpaceXxs}
/>
<div
  data-testid="File.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="bold"
 color={dtColorsNeutral900}
 textOverflow="ellipsis"
 overflowX="hidden"
 overflowY="hidden"
 whiteSpace="nowrap"
 data="video.file_name"
 text={videoFileNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 data="video.created_at"
 format="/Data/format.js dateISOToDateAndTime"
 text={videoCreatedAtValueData}
/>
</div>
</button>
<div
  data-testid="File.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}